import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    widgetsCollapsed: boolean;
  }>()
  .create(({ theme, widgetsCollapsed }) => {
    return {
      ticketsPage: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      },
      ticketsPageContent: {
        display: 'grid',
        flex: 1,
        gap: '1.5rem',
        gridTemplateColumns: widgetsCollapsed
          ? 'auto'
          : 'auto minmax(350px, 20vw)',
        gridTemplateRows: 'repeat(3, minmax(0, 1fr))',
        height: '100%',
        [theme.breakpoints.down('xl')]: {
          gridAutoFlow: 'row',
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gridTemplateRows: 'repeat(1, minmax(18.75rem, 1fr))'
        },
        [theme.breakpoints.down('md')]: {
          gridTemplateColumns: 'auto',
          gridTemplateRows: widgetsCollapsed ? 'auto' : 'repeat(3, auto)'
        },
        [theme.breakpoints.down('sm')]: {
          gridTemplateColumns: 'auto',
          gridTemplateRows: widgetsCollapsed ? 'auto' : 'repeat(3, auto)',
          gridAutoFlow: 'row'
        }
      },
      ticketsTable: {
        gridRow: 'span 3',
        minHeight: 300,
        overflow: 'auto',
        [theme.breakpoints.down('xl')]: {
          gridColumn: 'span 3',
          gridRow: 'span 1'
        },
        [theme.breakpoints.down('md')]: {
          gridColumn: 'span 1',
          gridRow: 'span 1',
          height: widgetsCollapsed ? 'auto' : '50vh',
          overflowX: 'auto'
        },
        [theme.breakpoints.down('sm')]: {
          gridColumn: 'span 1',
          gridRow: 'span 1',
          overflowX: 'auto'
        }
      },
      ticketsWidget: {
        [theme.breakpoints.up('xl')]: {
          height: '100%',
          minHeight: '33.33%'
        },
        [theme.breakpoints.down('xl')]: {
          gridRow: 'span 1',
          height: '18rem',
          minHeight: '100%'
        },
        [theme.breakpoints.down('md')]: {
          gridColumn: 'span 1'
        },
        [theme.breakpoints.down('sm')]: {
          gridColumn: 'span 1'
        }
      }
    };
  });

export default useStyles;
